import { render, staticRenderFns } from "./menusList.vue?vue&type=template&id=3dc5e628&scoped=true"
import script from "./menusList.vue?vue&type=script&lang=js"
export * from "./menusList.vue?vue&type=script&lang=js"
import style0 from "./menusList.vue?vue&type=style&index=0&id=3dc5e628&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc5e628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dc5e628')) {
      api.createRecord('3dc5e628', component.options)
    } else {
      api.reload('3dc5e628', component.options)
    }
    module.hot.accept("./menusList.vue?vue&type=template&id=3dc5e628&scoped=true", function () {
      api.rerender('3dc5e628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/menusList.vue"
export default component.exports